import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { Card, DynamicContent, Button, AuthComponent } from '../components';
import { routes, accountConstants } from '../constants';
import { AuthDelegate } from '../utils';
import { RouteActions } from '../actions';

const { statuses } = accountConstants;

class DeniedPage extends AuthComponent {

    componentWillMount(){
        super.componentWillMount();
        this.props.dispatch(RouteActions.setAppState(routes.DENIED));
    }

    userIsAuthorized(user) {
        return AuthDelegate.userHasApprovalState(statuses.DENIED)(user);
    }

    componentWillRejectUser() {
        browserHistory.push(routes.NOT_FOUND);
    }

    authRender () {
        return (
            <div className="container component-login-widget">
                <div className="row center-cols">
                    <div className="col-md-6 col-lg-5 center">
                        <Card>
                            <div className="card-title-area">
                                <h3>Access Denied</h3>
                            </div>
                            <DynamicContent>
                                <p>
                                    Access to your account has been denied. If you think this was a mistake, please <Link to={routes.CONTACT}>get in touch with us</Link>. In the meantime, feel free to learn more about our sample taking guidelines or our recommended flushing procedure.
                                </p>
                                <p>
                                    <Button to={routes.SAMPLING_GUIDELINES} className="primary">Sample Taking Guidelines</Button>
                                </p>
                                <p>
                                    <Button to={routes.FLUSHING_CONVERTING_PROCEDURE} className="primary">Recommended Flushing Procedure</Button>
                                </p>
                            </DynamicContent>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser
    }
}

export default connect(select)(DeniedPage);



// WEBPACK FOOTER //
// ./web-app/containers/denied.jsx